import { useState, useCallback } from 'react';
import { authApi } from '@/sdk/shared';
import type { ForgotPasswordRequest, ForgotPasswordResponse, ApiError } from '../types';

interface UseForgotPasswordReturn {
  forgotPassword: (data: ForgotPasswordRequest) => Promise<ForgotPasswordResponse>;
  isLoading: boolean;
  error: ApiError | null;
  clearError: () => void;
}

export const useForgotPassword = (): UseForgotPasswordReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<ApiError | null>(null);

  const forgotPassword = useCallback(async (data: ForgotPasswordRequest): Promise<ForgotPasswordResponse> => {
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await authApi.forgotPassword(data);
      return response;
    } catch (err) {
      const error = err as ApiError;
      setError(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    forgotPassword,
    isLoading,
    error,
    clearError,
  };
};
